import React from 'react';
import './Resources.css';

const Resources = () => {
  return (
    <div className="resources-page">
      <div className="resources-hero">
        <div className="container">
          <h1>Resources</h1>
          <p>Download key documents and resources (placeholders for future PDF and Word files).</p>
        </div>
      </div>

      <div className="container">
        <div className="resources-content">
          <section className="resources-section">
            <h2>Downloads</h2>
            <p>These are placeholders for future downloadable documents.</p>
            <div className="resources-grid">
              <div className="resource-card">
                <div className="resource-icon">
                  <i className="fas fa-file-pdf"></i>
                </div>
                <div className="resource-content">
                  <div className="resource-header">
                    <h3>How to Identify, Detect, and Report Interview Integrity Problems.</h3>
                    <span className="resource-type">PDF</span>
                  </div>
                  <p className="resource-description">
                    TBD
                  </p>
                  <button className="btn btn-primary" disabled>
                    <i className="fas fa-download"></i> Coming Soon
                  </button>
                </div>
              </div>

              <div className="resource-card">
                <div className="resource-icon">
                  <i className="fas fa-file-pdf"></i>
                </div>
                <div className="resource-content">
                  <div className="resource-header">
                    <h3>How non-immigration visas affect American entry level talent.</h3>
                    <span className="resource-type">PDF</span>
                  </div>
                  <p className="resource-description">
                    TBD
                  </p>
                  <button className="btn btn-primary" disabled>
                    <i className="fas fa-download"></i> Coming Soon
                  </button>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Resources; 